import { IAuthenticationService } from '@pit/core';
import { IDtoUser } from '@pit/frontend-model';
import { BehaviorSubject } from 'rxjs';

export interface IPinItTrackFrontendAuthenticationService extends IAuthenticationService {

    currentUser?: IDtoUser;
    currentUser$?: BehaviorSubject<IDtoUser>;

}
